import React, { forwardRef } from 'react';
import { Search } from 'lucide-react';
import Input from '../Input/Input';
import { cx } from '../utils';
import './SearchInput.css';

// Qidiruv ikonkali Input. label berilmasa, aria-label "Qidirish" bo'ladi (tashqaridan o'zgartirsa bo'ladi).
const SearchInput = forwardRef(function SearchInput(
  { label, placeholder = 'Qidirish...', wrapperClassName, ...rest },
  ref
) {
  return (
    <Input
      aria-label={label ? undefined : 'Qidirish'}
      {...rest}
      ref={ref}
      label={label}
      placeholder={placeholder}
      leftIcon={<Search />}
      wrapperClassName={cx('ui-search', wrapperClassName)}
    />
  );
});

export default SearchInput;
